import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { Button } from "../../Button/Button/Button";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import styles from "./SectionSeven.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SectionSeven = function SectionSeven(_ref) {
  var heading = _ref.heading,
    bodyText = _ref.bodyText,
    button = _ref.button;
  return /*#__PURE__*/_jsx("div", {
    className: styles.sectionSeven,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [heading && /*#__PURE__*/_jsx(HeadingText, {
        richText: true,
        align: "center",
        className: styles.heading,
        typog: heading.typog,
        ariaLevel: heading.ariaLevel,
        children: heading.text
      }), /*#__PURE__*/_jsx(Text, {
        align: "center",
        richText: true,
        className: styles.text,
        typog: "bodycopyExtraLarge",
        children: bodyText
      }), button && /*#__PURE__*/_jsx(Button, _objectSpread({
        className: styles.button
      }, button))]
    })
  });
};